"use strict";

const VISIBLE_CLASS = "visible";
const ACTIVE_POPUP_CLASS = "js-newsletter-popup-active";

const SELECTORS = {
    POPUP: ".js-popup",
    CLOSE_BUTTON: ".js-popup__close"
};

function showPopup(elem) {
    document.body.classList.add(ACTIVE_POPUP_CLASS);
    elem.classList.add(VISIBLE_CLASS);
}

function hidePopup(elem) {
    elem.classList.remove(VISIBLE_CLASS);
    document.body.classList.remove(ACTIVE_POPUP_CLASS);
}

export function init() {
    const popup = document.querySelector(SELECTORS.POPUP);

    if (!popup) {
        return false;
    }

    const popupId = popup.dataset.popupId;
    const popupStorageKey = "app.newsletter-hidden-" + popupId;
    const closeButton = popup.querySelector(SELECTORS.CLOSE_BUTTON);
    let isHidden;

    try {
        isHidden = localStorage.getItem(popupStorageKey);
    } catch (e) {
        console.warn(e);
    }

    if (!isHidden) {
        showPopup(popup);
    }

    closeButton.addEventListener("click", function () {
        hidePopup(popup);

        try {
            localStorage.setItem(popupStorageKey, true);
        } catch (e) {
            console.warn(e);
        }
    });
}
